/* What's new: the bell next to Help and Feedback and the release overlay it
   opens. Release popups never open by themselves any more — the red dot and a
   one-time peek of the tooltip do the announcing instead.

   The queue is whatever partial/whats-new.blade.php rendered (config
   release_popups.active): one slide behaves exactly like the old single
   popup, several become a stepper. Seen state is per update, marked the
   moment a slide is shown: signed-in users through markPopupSeenOnce
   (users.popup_views keeps the "seen at" timestamps), guests through the same
   popup_seen_<id> localStorage keys the old auto-popup wrote. */
(function () {
    'use strict';

    var btn = document.getElementById('whatsNewBtn');
    var ov = document.getElementById('wnOverlay');
    var tipEl = document.getElementById('wnTip');
    if (!btn || !ov || !tipEl) return;

    var slides = [].slice.call(ov.querySelectorAll('.wn-slide'));
    if (!slides.length) return;

    var FEATURES = slides.map(function (el) { return el.dataset.feat; });
    var isGuest = btn.dataset.guest === '1';
    var nav = ov.querySelector('.wn-nav');
    var dotsWrap = document.getElementById('wnDots');
    var prevBtn = ov.querySelector('[data-wn="prev"]');
    var nextBtn = ov.querySelector('[data-wn="next"]');
    var multi = slides.length > 1;
    var at = 0;
    var locked = false;

    /* runtime seen-set, seeded from the server (data-seen) or localStorage */
    var seen = {};
    var carryOver = [];
    slides.forEach(function (sl) {
        var id = sl.dataset.feat;
        if (isGuest) {
            try { seen[id] = localStorage.getItem('popup_seen_' + id) === '1'; } catch (e) { seen[id] = false; }
        } else {
            seen[id] = sl.dataset.seen === '1';
            /* what was viewed as a guest counts after signing in too: the
               localStorage mark the guest session left is carried into
               users.popup_views, so the red dot does not light up again */
            if (!seen[id]) {
                try {
                    if (localStorage.getItem('popup_seen_' + id) === '1') {
                        seen[id] = true;
                        carryOver.push(id);
                    }
                } catch (e) {}
            }
        }
    });
    /* one at a time: popup_views is a read-modify-write JSON column, and two
       parallel posts can overwrite each other's mark */
    if (carryOver.length && window.markPopupSeenOnce) {
        carryOver.reduce(function (chain, id) {
            return chain.then(function () { return window.markPopupSeenOnce(id); });
        }, Promise.resolve());
    }

    function markSeen(id) {
        if (seen[id]) return;
        seen[id] = true;
        if (isGuest) {
            try { localStorage.setItem('popup_seen_' + id, '1'); } catch (e) {}
        } else if (window.markPopupSeenOnce) {
            try { window.markPopupSeenOnce(id); } catch (e) {}
        }
    }
    function unseen() {
        return FEATURES.filter(function (id) { return !seen[id]; });
    }
    /* the header bell (phone only, CSS): visible exactly while news is unread */
    var topBtn = document.getElementById('wnTopBtn');
    function syncDot() {
        var n = unseen().length;
        btn.setAttribute('data-unseen', String(n > 0));
        if (topBtn) {
            topBtn.hidden = n === 0;
            /* the narrowest phones cannot seat the wordmark AND the bell —
               core.css drops the wordmark while this class is on */
            var header = document.getElementById('header');
            if (header) header.classList.toggle('has-wn-top', n > 0);
        }
        /* the label carries the news until everything has been viewed */
        tipEl.textContent = n === 0
            ? btn.dataset.tipIdle
            : (n === 1 ? btn.dataset.tipOne : btn.dataset.tipMany.replace(':n', String(n)));
    }
    syncDot();

    function isOpen() {
        return ov.classList.contains('modal-open');
    }

    /* all slides reserve the tallest slide's height, so the card never changes
       size and the nav outside it never moves out from under the pointer */
    function lockHeight() {
        var tallest = 0;
        slides.forEach(function (sl) {
            var was = sl.hidden;
            sl.hidden = false;
            tallest = Math.max(tallest, sl.offsetHeight);
            sl.hidden = was;
        });
        slides.forEach(function (sl) { sl.style.minHeight = tallest + 'px'; });
    }

    function go(i) {
        at = Math.max(0, Math.min(slides.length - 1, i));
        slides.forEach(function (sl) { sl.hidden = true; });
        slides[at].hidden = false;
        ov.setAttribute('data-slide', String(at));
        markSeen(FEATURES[at]);
        if (multi) {
            [].forEach.call(dotsWrap.children, function (d, n) {
                d.setAttribute('aria-selected', String(n === at));
                d.setAttribute('data-unseen', String(!seen[FEATURES[n]]));
            });
            prevBtn.disabled = at === 0;
            nextBtn.disabled = at === slides.length - 1;
        }
        syncDot();
    }

    if (multi) {
        nav.hidden = false;
        slides.forEach(function (sl, i) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'wn-dot-btn';
            d.setAttribute('role', 'tab');
            d.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
            d.addEventListener('click', function () { go(i); });
            dotsWrap.appendChild(d);
        });
        prevBtn.addEventListener('click', function () { go(at - 1); });
        nextBtn.addEventListener('click', function () { go(at + 1); });
    }

    /* Peek label: the tooltip shows itself once so the new control is noticed,
       then unsticks on a click anywhere, a hover over either button, or after
       a timeout. Scrolling deliberately does not dismiss it. */
    var peek = (function () {
        var helpBtn = document.querySelector('.feedback .feed-btn');
        var MAX_VISIBLE = 8000;
        var live = false, timer, wait;
        function drop() {
            clearTimeout(wait);
            if (!live) return;
            live = false;
            tipEl.classList.remove('is-peek');
            clearTimeout(timer);
            document.removeEventListener('pointerdown', drop, true);
            btn.removeEventListener('mouseenter', drop);
            if (helpBtn) helpBtn.removeEventListener('mouseenter', drop);
        }
        function show(delay) {
            drop();
            if (!unseen().length) return;
            wait = setTimeout(function () {
                if (!unseen().length) return;
                live = true;
                tipEl.classList.add('is-peek');
                timer = setTimeout(drop, MAX_VISIBLE);
                document.addEventListener('pointerdown', drop, true);
                btn.addEventListener('mouseenter', drop);
                if (helpBtn) helpBtn.addEventListener('mouseenter', drop);
            }, delay);
        }
        return { show: show, drop: drop };
    })();
    peek.show(800);

    function open() {
        ov.classList.add('modal-open');
        document.body.classList.add('modal-open');
        ov.setAttribute('aria-hidden', 'false');
        if (!locked && multi) {
            lockHeight();
            locked = true;
        }
        /* open on the first update that has not been viewed yet */
        var next = FEATURES.indexOf(unseen()[0]);
        go(next === -1 ? 0 : next);
        var close = document.getElementById('wnClose');
        if (close) close.focus();
    }
    function close() {
        ov.classList.remove('modal-open');
        document.body.classList.remove('modal-open');
        ov.setAttribute('aria-hidden', 'true');
    }

    btn.addEventListener('click', function () {
        if (isOpen()) close();
        else open();
    });
    if (topBtn) topBtn.addEventListener('click', function () {
        if (isOpen()) close();
        else open();
    });
    document.getElementById('wnClose').addEventListener('click', close);
    ov.addEventListener('click', function (e) {
        /* "Maybe later" and any slide CTA marked as a dismiss (delegated:
           slides differ in which of their buttons closes) */
        if (e.target.closest('[data-popup-dismiss]')) { close(); return; }
        if (e.target === ov || e.target.classList.contains('modal-dialog')) close();
    });
    document.addEventListener('keydown', function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') close();
        if (multi && e.key === 'ArrowRight') go(at + 1);
        if (multi && e.key === 'ArrowLeft') go(at - 1);
    });
})();
